
export const solutions = {
  '1gb.solutions': '1Gb-ratkaisut',
  '10gb.solutions': '10Gb-ratkaisut',
  '1gb.vpx.accessories': '1Gb VPX -lisävarusteet',
  'software': 'Ohjelmisto',
  '1gb.description': 'Tehokkaat 1Gb AV over IP -ratkaisut',
  '10gb.description': 'Huipputehokkaat 10Gb AV over IP -ratkaisut',
  'vpx.accessories.description': 'Välttämättömät lisävarusteet 1Gb VPX -ratkaisuihin',
  'software.description': 'Aurora IPBaseT Manager -ohjelmisto on all-in-one-hallintasovellus Auroran IPBaseT AV over IP -tuotteiden IPX-, VPX- ja VLX-sarjoille',
  'avoip.solutions': 'AVOIP-ratkaisut',
  'choose.network.speed': 'Valitse haluamasi verkkopeus',
  'touch.controllers': 'Kosketusohjaimet',
  'touch.controllers.description': 'Ammattimaiset kosketuspaneeliliittymät saumattomaan ohjaukseen',
  'control.processors': 'Ohjainprosessorit',
  'control.processors.description': 'Edistyneet ohjainprosessorit järjestelmänhallintaan',
  'reax.software': 'Ohjelmisto',
  'reax.software.description': 'Ammattimainen ohjausjärjestelmän kehitysohjelmisto',
  'reax.accessories': 'Lisävarusteet',
  'reax.accessories.description': 'Välttämättömät lisävarusteet ReAX-järjestelmiin',
  'reax.control.solutions': 'ReAX-ohjausratkaisut',
  'choose.control.solution': 'Valitse haluamasi ohjausratkaisu',
  'digital.signal.processors': 'Digitaaliset signaaliprosessorit',
  'dsps.description': 'Ammattimaiset äänenkäsittelyratkaisut',
  'amplifiers': 'Vahvistimet',
  'amplifiers.description': 'Tehokas äänen vahvistus',
  'speakers': 'Kaiuttimet',
  'speakers.description': 'Premium-äänentoistoratkaisut',
  'audio.solutions': 'Ääniratkaisut',
  'choose.audio.solution': 'Valitse haluamasi ääniratkaisu',
};
